import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [CommonModule, MatCardModule,
        MatInputModule, MatFormFieldModule, MatButtonModule, ReactiveFormsModule, MatSelectModule, MatTooltipModule, MatGridListModule, MatListModule, MatSidenavModule,
        MatToolbarModule, TranslateModule],
    exports: [CommonModule,  MatCardModule,
        MatInputModule, MatFormFieldModule, MatButtonModule, ReactiveFormsModule, MatSelectModule, MatIconModule, MatTooltipModule, MatGridListModule,  MatListModule, MatSidenavModule,
        MatToolbarModule, TranslateModule]
})
export class SharedModule { }